<template>
    <div>
        <div class="media-content">
            <div class="field">
                <p class="control">
                    <editable
                        v-model="comment.body"
                        @send="saveChangedComment"
                    />
                </p>
            </div>
        </div>
        <comment-send-cancel-buttons
            :trans="trans"
            :isRequestInProgress="isRequestInProgress"
            @isAction="isAction($event)"
        />
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

import Editable from "../../Editable";
import CommentSendCancelButtons from "./CommentSendCancelButtons";

export default {
    name: "EditComment",
    components: {
        Editable,
        CommentSendCancelButtons,
    },
    props: [
        'commentText',
    ],
    data() {
        return {
            comment: {
                body: this.commentText,
            },
        }
    },
    computed: {
        ...mapState('comment', [
            'trans',
        ]),
        ...mapGetters('comment', [
            'isRequestInProgress',
        ]),
    },
    methods : {
        ...mapActions('comment', [
            'editComment',
            'unsetEditingBlocked',
            'showCommentErrorDocumentDeletedModal',
        ]),
        isAction(value) {
            value ? this.saveChangedComment() : this.cancelCommentChanges();
        },
        saveChangedComment() {
            if (this.commentText !== JSON.parse(JSON.stringify(this.comment.body))) {
                this.editComment(this.comment)
                    .then(response => {
                        this.unsetEditingBlocked(false);
                        this.$emit('done');
                    })
                    .catch(error => {
                        if (error.response.status === 404) {
                            this.showCommentErrorDocumentDeletedModal(true);
                        }

                        this.showNotification(error.response.data.errors.body[0], 680);
                    })
            }

        },
        cancelCommentChanges() {
            this.unsetEditingBlocked(false);
            this.$emit('done');
        },
    },
}
</script>

<style lang="css" scoped>
    .control {
        min-width: calc(100% - 2px);
        max-width: calc(100% - 2px);
    }
</style>
